import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ModuleList from './components/ModuleList';
import ModuleDetails from './components/ModuleDetails';
import TransferDocuments from './components/TransferDocuments';
import DocumentSummary from './components/DocumentSummary';
import Login from './components/Login';
import AdminRegister from './components/AdminRegister';

import PrivateRoute from './components/PrivateRoute';
import Navigation from './components/Navigation';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Navigation />
        <Container>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/admin/register" element={<PrivateRoute><AdminRegister /></PrivateRoute>} />
            <Route path="/" element={<PrivateRoute><ModuleList /></PrivateRoute>} />
            <Route path="/modules/:id" element={<PrivateRoute><ModuleDetails /></PrivateRoute>} />
            <Route path="/transfer" element={<PrivateRoute><TransferDocuments /></PrivateRoute>} />
            <Route path="/summary/:id" element={<PrivateRoute><DocumentSummary /></PrivateRoute>} />
          </Routes>
        </Container>
      </Router>
    </AuthProvider>
  );
}

export default App;
